<template>
  <div class="ActivityDiscount">
    <img :src="imgUrl" alt="大方租车 押金双免"/>
    <div class="btn btn1">
      <div @click="getActivityDiscount"></div>
    </div>
    <div class="btn btn2">
      <div @click="goHome"></div>
    </div>
  </div>
</template>

<script>
  import { orderSource } from "@/utils/env";
  import { getConsumerCoupons, DrawCoupon } from "@/utils/api";
  export default {
    name: 'visitHubei',
    data(){
      return {
        imgUrl: 'https://cms.dafang24.com/aliapp/2020/visitHubei.png',
        couponList: [
          {
            name: "20元无门槛券，1天起租可用，仅限湖北地区。",
            OfferID: 323
          },
          {
            name: "连续租满2天立减50元，周末可用，节假日不可用。",
            OfferID: 303
          },
          {
            name: "连续租满4天立减120元，周末可用，节假日不可用。",
            OfferID: 302
          },
          {
            name: "连续租满7天立减210元，周末可用，节假日不可用。",
            OfferID: 301
          }
        ]
      }
    },
    created () {},
    mounted () {},
    methods: {
      getActivityDiscount(){
        if( localStorage.getItem('token') ){
          let couponList = this.couponList;
          this.consumerCouponsFn(couponList);
        } else {
          this.flexible.showToast({
            content:'请先登陆/注册！',
            success:()=>{
              this.goLogin();
            }
          });
        }
      },
      goLogin () {
        if( orderSource==17 ){
          window.webkit.messageHandlers.openPage.postMessage(JSON.stringify({type: "app", url: "/LonginActivity"}));
        } else if ( orderSource==16 ){
          dfpanda.openPage(JSON.stringify({type: "app", url: "/app/LonginActivity"}));
        }
      },
      goHome () {
        if( orderSource==17 ){
          window.webkit.messageHandlers.goHome.postMessage();
        } else if ( orderSource==16 ){
          dfpanda.goHome();
        }
      },
      async consumerCouponsFn (copList) { // 获取用户优惠券
        let res = await getConsumerCoupons();
        if( res.Code==100 ){
          let uCoupon = res.Data || [];
          if( uCoupon.length ){
            for( let i in uCoupon ){
              for( let j in copList ){
                if( uCoupon[i].OfferID == copList[j].OfferID ){
                  copList.splice(j, 1);
                }
              }
            }
          }
          if( copList.length ){
            let lastRes = false;
            for( let item of copList ){
              let gRes = await this.getDrawCoupon(item.OfferID);
              if( gRes ){ lastRes = gRes }
            }
            if( lastRes ){
              this.flexible.showToast({
                duration:1200,
                content:'领取成功！'
              });
            } else {
              this.flexible.showToast({content:'领取失败，请重试'})
            }
          } else {
            this.flexible.showToast({
              duration:1200,
              content:'领取成功！'
            })
            // this.flexible.showToast({
            //   duration:1200,
            //   content:'领取成功！去租车',
            //   success:()=>{
            //     this.goHome()
            //   }
            // })
          }
        } else if( res.Code==17007 ) {
          this.goLogin()
        }
      },
      async getDrawCoupon ( offerID ) {
        let res = await DrawCoupon({
          data: {
            OfferID: offerID,
            orgID: 0
          },
          isLoading: 1,
          loadContent: '获取优惠券...'
        });
        if( res.Code==100 ){
          return true;
        }
        return false;
      }
    }
  }
</script>
<style lang="scss" scoped>
  .ActivityDiscount {
    position: relative;
    img {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: center;
      div {
        display: inline-block;
        /*background-color: rgba(0,0,0, .5);*/
      }
    }
    .btn1 {
      top: 840px;
      div {
        width: 620px;
        height: 320px;
      }
    }
    .btn2  {
      top: 4400px;
      div {
        width: 620px;
        height: 320px;
      }
    }
    .showCarList {
      .carListTitle {
        width: 100%;
        padding-top: 60px;
        padding-bottom: 40px;
        text-align: center;
        img {
          width: 272px;
        }
      }
      .cityList {
        display: flex;
        flex-wrap: wrap;
        padding: 0 20px 28px;
        .cityItem {
          width: 128px;
          height: 56px;
          line-height: 56px;
          border: 1px solid #fff; /* no */
          color: #fff;
          margin: 20px 5px 0;
          border-radius: 64px;
          text-align: center;
        }
        .active {
          border-color: #FFD200;
          background-color: #FFD200;
          color: #6063F2;
        }
      }
      .carList {
        .carItem {
          display: flex;
          width: 690px;
          margin: 20px auto 0;
          background-color: #fff;
          border-radius: 28px;
          padding: 30px 40px;
          box-sizing: border-box;
          align-items: center;
          .carImg {
            position: relative;
            img {
              width: 216px;
              height: 110px;
            }
            .hotIcon {
              position: absolute;
              top: -20px; right: -10px;
              width: 116px;
              height: 46px;
            }
          }
          .carInfo {
            margin-left: 40px;
            width: 360px;
            .carClass {
              width: 100%;
              color: #232323;
              font-size: 26px;
              font-weight: bold;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .carCharacteristic {
              font-size: 20px;
              color: #8B8B8B;
              height: 60px;
            }
            .carPrice {
              font-size: 22px;
              color: #8B8B8B;
              .priceIcon {
                color: #FF3600;
                font-size: 26px;
              }
              .priceNum {
                font-size: 40px;
                color: #FF3600;
              }
            }
          }
        }
      }
    }
    .goRentCarBox {
      margin-top: 45px;
      padding-bottom: 60px;
      .goRentCar {
        width:690px;
        height:90px;
        margin: 0 auto;
        line-height: 90px;
        text-align: center;
        background-color: #FFD200;
        font-size: 30px;
        color: #7B7EF9;
        border-radius: 45px;
      }
    }
  }
</style>
